var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-padding" },
    [
      _c(
        "h5",
        { staticStyle: { "padding-bottom": "30px" } },
        [
          _c("q-icon", { attrs: { name: "fa fa-bell-o", color: "primary" } }),
          _vm._v(" Notification Settings")
        ],
        1
      ),
      _vm._m(0),
      _vm._l(_vm.authorizedNotificationItems, function(notification, i) {
        return _c("div", { key: i, staticClass: "sl-row" }, [
          _c("div", { staticClass: "sl-col-8" }, [
            _vm._v("\n        " + _vm._s(notification.description) + "\n      ")
          ]),
          _c(
            "div",
            { staticClass: "sl-col-2 text-center" },
            [
              _c("q-checkbox", {
                model: {
                  value: notification.email,
                  callback: function($$v) {
                    _vm.$set(notification, "email", $$v)
                  },
                  expression: "notification.email"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sl-col text-center" },
            [
              _c("q-checkbox", {
                model: {
                  value: notification.inapp,
                  callback: function($$v) {
                    _vm.$set(notification, "inapp", $$v)
                  },
                  expression: "notification.inapp"
                }
              })
            ],
            1
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sl-row text-bold" }, [
      _c("div", { staticClass: "sl-col-8" }, [
        _vm._v("\n        Description\n      ")
      ]),
      _c("div", { staticClass: "sl-col-2 text-center" }, [_vm._v("E-mail")]),
      _c("div", { staticClass: "sl-col-2 text-center" }, [_vm._v("In App")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }